var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('b-button',{staticClass:"m-t-15 m-b-15",attrs:{"variant":"primary"},on:{"click":_vm.add}},[_c('i',{staticClass:"icon-plus"}),_vm._v(" Ver mas ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }